
import * as types from "./types";
import { JSON_STRING, HttpClient, MHTTPCL } from "../../../../services/http/http-client";
import { getNavTabModule } from "../../../../dt-plugins/sidewindow/nav-tab";

import { EOL_REACHED } from "../../../../dt-plugins/advanced-search/load.model";
import { setMainNavInactive } from "../../../../store/app/mutations";

import router from '../../../../router';
import { DistributionStatementService } from "../../services/statement.service";
import { DistributionReleaseReportService } from "../../services/release.report.service";

//const NavTabModule = getNavTabModule(types.DistributionStatementsDetails, 'distributionStatementDetails');
export const distributionReleaseReportActions = {


  async [types.DistributionReleaseReportList.FETCH.ALL]({ commit, getters, dispatch }, payload) {
    const { start, row_count, searchMode, basicFilter, searchFilter } = payload;


    let res;
    console.log("PAYLOAD Filter", payload);

    if (searchMode == 'none') {
      if (start == 0) {
        res = await HttpClient.mergeRequests([
          DistributionReleaseReportService.releaseReportTab(),
          DistributionReleaseReportService.filterReleases({str:'' ,artist:'' ,release_type:'',status:'' ,label_id:'',start:0})
        ]);

        console.log("RES", res)

        commit(types.DistributionReleaseReportList.SET.ALL, res);  // <-- Directly Set the Data. Depends on your particular Logic
      } else {                // <-- Pagination Logic
        res = await DistributionReleaseReportService.filterReleases({str:'' ,artist:'' ,release_type:'',status:'' ,label_id:'',start:start})            // <-- Pagination Logic

        console.log("res", res)

        commit(types.DistributionReleaseReportList.SET.ALL, { // <-- Set the Data. Here the actual List is nested. Depends on your particular case
          ...getters.distributionReleaseReportList,
          releases: [
            ...getters.distributionReleaseReportList.releases,
            ...res.data.releases, // <-- append new Fetched List
          ]
        });

        // Setting EOL
        // if (!(res?.data?.length <= 0)) {
        //   return EOL_REACHED;
        // }
      }

    } else if (searchMode == 'basic') {
      const { searchString, licence_statuses, royalty_period, invoice_project, statement_type } = basicFilter;

      
      console.log("res filter", res)
      if (start == 0) {
        
        res = await DistributionReleaseReportService.filterReleases({ ...basicFilter ,start:0 ,str:searchString });

        commit(types.DistributionReleaseReportList.SET.ALL, {// <-- Set the Data. Here the actual List is nested. Depends on your particular case
          ...getters.distributionReleaseReportList,
          releases: [
            ...res.data.releases, // <-- append new Fetched List
          ]
        });
      }
      else {                // <-- Pagination Logic
        res = await DistributionReleaseReportService.filterReleases({ ...basicFilter ,start:start ,str:searchString });
        commit(types.DistributionReleaseReportList.SET.ALL, {               // <-- Pagination Logic
          ...getters.distributionReleaseReportList,
          releases: [
            ...getters.distributionReleaseReportList.releases,
            ...res.data.releases, // <-- append new Fetched List
          ]
        });
      }


      // Setting EOL
      // if (!(res?.data?.length > 0)) {
      //   return EOL_REACHED;
      // }
    }
  },



}
